<form [formGroup]="filterForm">
  <div class="datepicker">
    <app-datepicker
      formControlName="fromDate"
      [placeholder]="'home.filter.placeholder.fromDate' | translate"
      [maxDate]="filterForm.get('toDate').value"
    >
    </app-datepicker>

    <app-datepicker
      formControlName="toDate"
      [placeholder]="'home.filter.placeholder.toDate' | translate"
      [minDate]="filterForm.get('fromDate').value"
      [useEndOfDay]="true"
    >
    </app-datepicker>
  </div>

  <div class="filter">
    <select type="text" formControlName="pos" class="input">
      <option
        [value]="''"
        [selected]="!currentFilter || currentFilter.pos == ''"
      >
        {{ "home.filter.placeholder.pos" | translate }}
      </option>
      <option
        *ngFor="let p of availablePos"
        [value]="p.id"
        [selected]="currentFilter && currentFilter.pos === p.id"
      >
        {{ p.name }}
      </option>
    </select>
    <button
      class="btn print"
      type="button"
      [title]="'home.filter.placeholder.print' | translate"
      (click)="onPrint()"
    >
      <i class="fas fa-print"></i>
    </button>
  </div>
</form>
